import { Component } from '@angular/core';

@Component({
  selector: 'app-gri-disclaimer',
  templateUrl: './gri-disclaimer.component.html',
})
export class GriDisclaimerComponent {}
